module.exports = __webpack_public_path__ + "img/android_black.a74c2074.svg";